"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryKeys = exports["default"] = void 0;

var _reactQuery = require("react-query");

var _filterUtils = require("@nicbase/filter-utils");

var _request = require("@nicbase/request");

var _types = require("@nicbase/types");

var _nicbaseSecurity = require("nicbase-security");

var _portalQueryKey = _interopRequireDefault(require("./portalQueryKey"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var findLatestData = function findLatestData(portalId) {
  var dynamicFilters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return {
    type: 'FIND_LATESTDATA_REQUEST',
    headers: {
      version: 'v1',
      portalId: portalId
    },
    body: {
      dynamicFilters: dynamicFilters,
      dynamicSorters: null,
      dynamicPaging: null
    }
  };
};

var queryKeys = {
  all: function all(portalId) {
    return [].concat(_toConsumableArray((0, _portalQueryKey["default"])(portalId)), ['latestData']);
  }
};
exports.queryKeys = queryKeys;

var usePortalLatestData = function usePortalLatestData(portalId) {
  var filters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  var _useRequest = (0, _request.useRequest)(),
      request = _useRequest.request;

  var _usePermissions = (0, _nicbaseSecurity.usePermissions)('PORTAL'),
      hasPermissions = _usePermissions.hasPermissions;

  return (0, _reactQuery.useQuery)([].concat(_toConsumableArray(queryKeys.all(portalId)), [filters]), /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var _ref2, assetId, assetIds, assetGroupId, assetGroupIds, position, status, _and, filterTree, _yield$request, body;

    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _ref2 = filters !== null && filters !== void 0 ? filters : {}, assetId = _ref2.assetId, assetIds = _ref2.assetIds, assetGroupId = _ref2.assetGroupId, assetGroupIds = _ref2.assetGroupIds, position = _ref2.position, status = _ref2.status;
            _and = (0, _filterUtils.and)((0, _filterUtils.equal)('latestData.assetId', assetId, _types.FilterAttributeType.Integer), (0, _filterUtils.equal)('latestData.assetGroupId', assetGroupId, _types.FilterAttributeType.Integer), (0, _filterUtils.isIn)('latestData.assetId', assetIds, _types.FilterAttributeType.Integer), (0, _filterUtils.isIn)('latestData.assetGroupId', assetGroupIds, _types.FilterAttributeType.Integer), (0, _filterUtils.like)('latestData.positionSearchTag', position, _types.FilterAttributeType.String), (0, _filterUtils.makeStatusFilterFunction)('latestData.status', status)), filterTree = _and.filterTree;
            _context.next = 4;
            return request(findLatestData(portalId, filterTree));

          case 4:
            _yield$request = _context.sent;
            body = _yield$request.body;
            return _context.abrupt("return", body === null || body === void 0 ? void 0 : body.latestData);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), _objectSpread(_objectSpread({}, options), {}, {
    enabled: hasPermissions(['module.latestData.read']) && options.enabled
  }));
};

var _default = usePortalLatestData;
exports["default"] = _default;